'use client';

import React from 'react';

const NEWS_ITEMS = [
  "++ EILMELDUNG: Pizza-Index erreicht Rekordhoch ++",
  "++ KRYPTO-UPDATE: Salz-Gehalt in R6 Vegas steigt um 500% ++",
  "++ WETTER: Stürmische Zeiten in Tempest Rising erwartet - Warnstufe Rot ++",
  "++ MARKT: Koffein-Reserven fallen kritisch - Nachschub gefordert ++",
  "++ TECHNIK: 'Es liegt nicht am Ping, du triffst einfach nicht' bestätigt führender Wissenschaftler ++",
  "++ SPORT: Patrick verfehlt Klick - Mauspad verantwortlich gemacht ++",
  "++ VERKEHR: Stau am Supply Drop - Wartezeiten für Bier bei 2 Minuten ++",
  "++ SECURITY: Firewall meldet Angriff durch 'User Dummheit' ++",
  "++ SYSTEM: Windows Update plant Neustart in 5 Minuten... Spaß! (Vielleicht) ++",
  "++ FORSCHUNG: Zusammenhang zwischen Energy-Drink-Konsum und Herzrasen bewiesen ++",
  "++ LOKALES: Unbekannter Spieler fragt 'Welches Spiel spielen wir?' zum 10. Mal ++",
  "++ WIRTSCHAFT: Aktienkurs von Lieferando explodiert ++",
  "++ GESUNDHEIT: Schlafmangel führt zu Halluzinationen - Gegner sehen, wo keine sind ++",
  "++ SKANDAL: Aimbot-Vorwürfe gegen den Host laut geworden ++",
  "++ TIPP: Wer später bremst, fährt länger schnell ++",
  "++ CRIME: Letztes Stück Pizza entwendet - SOKO 'Salami' ermittelt ++",
  "++ HARDWARE: RGB-Beleuchtung erhöht Skill um 15% (wissenschaftlich widerlegt) ++",
  "++ NETZWERK: Jemand lädt Pornos... äh, Linux-ISOs runter! Ping bei 900ms ++",
  "++ BREAKING: C&C Sammler wieder dumm wie Brot - Wegfindung in der Sackgasse ++",
  "++ LIVE: 'Nur noch eine Runde' dauert bereits 3 Stunden an ++"
];

export default function NewsTicker() {
  return (
    // Added !important utilities to ensure visibility across themes
    <div className="fixed bottom-0 left-0 right-0 bg-red-900/90 border-t border-red-700 text-white z-[9999] h-8 flex items-center overflow-hidden theme-ticker-root">
      <div className="bg-red-800 px-3 h-full flex items-center font-black uppercase tracking-widest text-xs z-10 shadow-xl theme-ticker-label">
        LAN-NEWS
      </div>
      <div className="flex-1 overflow-hidden relative flex items-center">
        <div className="animate-marquee whitespace-nowrap flex items-center gap-16 text-xs font-bold font-mono tracking-wider theme-ticker-text">
          {NEWS_ITEMS.map((item, i) => (
            <span key={i} className="flex items-center gap-2">
              <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse theme-ticker-dot"></span>
              {item}
            </span>
          ))}
          {/* Duplicate for seamless loop */}
          {NEWS_ITEMS.map((item, i) => (
            <span key={`dup-${i}`} className="flex items-center gap-2">
              <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse theme-ticker-dot"></span>
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

